import { useState } from "react"

export const VariableAccounts =() => {
    const [state, setState] = useState({
        name: '',
        type: '',
        amount: '',
        status: "active",
        account_type_id: "",
        account_type_name: "",
        statusFilter: "",
        user_id: "",
        user_name: "",
        open: false,
        openEdit: false,
        openDetails: false,
        arr1: [],
        Load: false
    })
    const setStateCustom = (variableName, value) => {
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    const setLoad = (value) => {
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
    const setOpen = (value) => {
        setState((prevState) => ({
            ...prevState,
            open: value,
        }));
    };
    const setOpenDetails = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            openDetails: value,
        }));
    };
    const setopenEdit = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            openEdit: value,
        }));
    };
    const handleEdit= (event, arr) => {
        event.preventDefault();
        setState((prevState) => ({
            ...prevState,
            arr1: arr,
            openEdit: true
        }));
    }
  return {
    ...state,
    state,
    setState,
    handleEdit,
    setOpen,
    setopenEdit,
    setStateCustom,
    setLoad,setOpenDetails
  }
}
